import { TieredMenu } from "primereact/tieredmenu";
import { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const Sidebar = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const sideBarItems = useMemo(
    () => [
      {
        label: "Списък",
        icon: "pi pi-list",
        command: () => {
          navigate("/protocols");
        },
        className: pathname === "/protocols" ? "p-focus" : "",
      },
      {
        label: "Нов протокол",
        icon: "pi pi-plus",
        command: () => {
          navigate("/protocols/create");
        },
        className: pathname === "/protocols/create" ? "p-focus" : "",
      },
      {
        label: "Нов протокол за признаване на оценки",
        icon: "pi pi-plus",
        command: () => {
          navigate("/protocols/createRecognitionProtocol");
        },
        className: pathname === "/protocols/createRecognitionProtocol" ? "p-focus" : "",
      },
    ],
    [pathname],
  );

  return <TieredMenu model={sideBarItems} breakpoint="767px" className="w-full" />;
};

export default Sidebar;
